export default [
	//佣金管理
	{
		path: '/yongjin',
	  component: () => import('@/views/yongjin/yongjinshouru/index'),
	  redirect:'/yongjin/yongjinwai',
	  children:[
	    {
	      path: '/yongjin/yongjinwai',
	      component: () => import('@/views/yongjin/yongjinshouru/yongjinwai'),
	      mete:{
	        title:"系统外佣金收入",
	      },
	    },
	    {
	      path: '/yongjin/yongjinnei',
	      component: () => import('@/views/yongjin/yongjinshouru/yongjinnei'),
	      mete:{
	        title:"系统内佣金收入",
	      },
	    },
      {
        path: '/yongjin/yongjinchaxun',
        component: () => import('@/views/yongjin/yongjinshouru/yongjinchaxun'),
        mete:{
          title:"佣金收入查询",
        },
      },
      {
        path: '/yongjin/yongjinbaobiao',
        component: () => import('@/views/yongjin/yongjinshouru/yongjinbaobiao'),
        mete:{
          title:"佣金收入报表",
        },
      },
      {
        path: '/yongjin/yongjinguize',
        component: () => import('@/views/yongjin/yongjinshouru/yongjinguize'),
        mete:{
          title:"佣金规则",
        },
      },
	  ]
	},
  {
  	path: '/yongjinzhichu',
    component: () => import('@/views/yongjin/yongjinzhichu/index'),
    redirect:'/yongjinzhichu/zhichuguanli',
    children:[
      {
        path: '/yongjinzhichu/zhichuguanli',
        component: () => import('@/views/yongjin/yongjinzhichu/zhichuguanli'),
        mete:{
          title:"佣金支出管理",
        },
      },
      {
        path: '/yongjinzhichu/zhichudakuan',
        component: () => import('@/views/yongjin/yongjinzhichu/zhichudakuan'),
        mete:{
          title:"支出打款",
        },
      },
      {
        path: '/yongjinzhichu/yongjinbaimingdan',
        component: () => import('@/views/yongjin/yongjinzhichu/yongjinbaimingdan'),
        mete:{
          title:"佣金白名单",
        },
      },

      {
        path: '/yongjinzhichu/zhichudakuanshenhe',
        component: () => import('@/views/yongjin/yongjinzhichu/zhichudakuanshenhe'),
        mete:{
          title:"支出打款审核",
        },
      },
      {
        path: '/yongjinzhichu/yongjinzhichu',
        component: () => import('@/views/yongjin/yongjinzhichu/yongjinzhichu'),
        mete:{
          title:"佣金支出",
        },
      },
      {
        path: '/yongjinzhichu/yongjinzhichubaobiao',
        component: () => import('@/views/yongjin/yongjinzhichu/yongjinzhichubaobiao'),
        mete:{
          title:"佣金支出报表",
        },
      },
	  {
	    path: '/yongjinzhichu/caiwupeizhi',
	    component: () => import('@/views/yongjin/yongjinzhichu/caiwupeizhi'),
	    mete:{
	      title:"财务配置",
	    },
	  },
      {
        path: '/yongjinzhichu/zhichupeizhi',
        component: () => import('@/views/yongjin/yongjinzhichu/zhichupeizhi'),
        mete:{
          title:"支出配置",
        },
      },
      {
        path: '/yongjinzhichu/zhichuguanli/daorubiao',
        component: () => import('@/views/yongjin/yongjinzhichu/daorubiao'),
        mete:{
          title:"导入表",
        },
      },
      {
        path: '/yongjinzhichu/zhichuguanli/daorubiaox',
        component: () => import('@/views/yongjin/yongjinzhichu/daorubiaox'),
        mete:{
          title:"导入表",
        },
      },

      {
        path: '/yongjinzhichu/zhichuguanli/zhichushenhejilu',
        component: () => import('@/views/yongjin/yongjinzhichu/zhichushenhejilu'),
        mete:{
          title:"支出审核导入记录",
        },
      },

      {
        path: '/yongjinzhichu/zhichudakuan/fapiao',
        component: () => import('@/views/yongjin/yongjinzhichu/fapiao'),
        mete:{
          title:"发票配置",
        },
      },

    ]
  },
  {
  	path: '/yongjintixian',
    component: () => import('@/views/yongjin/yongjintixian/index'),
    redirect:'/yongjintixian/yongjintixian',
    children:[
      {
        path: '/yongjintixian/yongjintixian',
        component: () => import('@/views/yongjin/yongjintixian/yongjintixian'),
        mete:{
          title:"佣金提现",
        },
      },
      {
        path: '/yongjintixian/tixianjilu',
        component: () => import('@/views/yongjin/yongjintixian/tixianjilu'),
        mete:{
          title:"提现记录",
        },
      },
      {
        path: '/yongjintixian/mingxi',
        component: () => import('@/views/yongjin/yongjintixian/mingxi'),
        mete:{
          title:"佣金明细核对",
        },
      },
    ]
  },
  {
  	path: '/yongjindakuan',
    component: () => import('@/views/yongjin/yongjindakuan/index'),
    redirect:'/yongjindakuan/yongjindakuan',
    children:[
      {
        path: '/yongjindakuan/yongjindakuan',
        component: () => import('@/views/yongjin/yongjindakuan/yongjindakuan'),
        mete:{
          title:"佣金打款",
        },
      }
    ]
  },
  {
  	path: '/yongjinbaobiao',
    component: () => import('@/views/yongjin/yongjinbaobiao/index'),
    redirect:'/yongjinbaobiao/shangpinbaobiao',
    children:[
      {
        path: '/yongjinbaobiao/shangpinbaobiao',
        component: () => import('@/views/yongjin/yongjinbaobiao/shangpinbaobiao'),
        mete:{
          title:"商品佣金报表",
        },
      },
      {
        path: '/yongjinbaobiao/qudaobaobiao',
        component: () => import('@/views/yongjin/yongjinbaobiao/qudaobaobiao'),
        mete:{
          title:"渠道报表",
        },
      },
      {
        path: '/yongjinbaobiao/xiaoshouqudaofenxi',
        component: () => import('@/views/yongjin/yongjinbaobiao/xiaoshouqudaofenxi'),
        mete:{
          title:"销售渠道报表",
        },
      },
      {
        path: '/yongjinbaobiao/chanpinqudaofenxi',
        component: () => import('@/views/yongjin/yongjinbaobiao/chanpinqudaofenxi'),
        mete:{
          title:"产品渠道分析",
        },
      },

    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/yongjin.js